import { useEffect } from 'react';

import { setCurrentIamPlacement, trackBrazeIamScreenShown } from 'apps/auth/analytics/braze';

type BrazeIamScreenProperties = Record<string, unknown>;

interface BrazeIamScreenOptions {
    enabled?: boolean;
    ready?: boolean;
}

// Sets the current placement on mount so a delayed message cannot render on the wrong screen,
// fires the screen's trigger event once ready, and clears the placement on unmount.
export const useBrazeIamScreen = (
    eventName: string,
    placementId: string,
    properties: BrazeIamScreenProperties = {},
    options: BrazeIamScreenOptions = {},
): void => {
    const { enabled = true, ready = true } = options;
    const serializedProperties = JSON.stringify(properties);

    useEffect(() => {
        if (!__isBrowser__ || !enabled) {
            return undefined;
        }
        setCurrentIamPlacement(placementId);
        return () => setCurrentIamPlacement(null);
    }, [enabled, placementId]);

    useEffect(() => {
        if (!__isBrowser__ || !enabled || !ready) {
            return;
        }
        trackBrazeIamScreenShown(eventName, placementId, properties);
    }, [enabled, ready, eventName, placementId, serializedProperties]);
};
